module.exports = __webpack_public_path__ + "img/bg.415f232b.jpg";